<template>
  <section class="relative pb-0 mb-0">
    <tilted-background background-color="bg-summer-yellow-6">
      <div class="container p-4">
        <div
          class="pb-18 relative flex z-10 flex-col-reverse justify-between items-center m:flex-row pt-2 l:pt-16 l:pb-28 l:mb-6"
        >
          <div class="mt-8 m:mt-0 m:w-7/12 l:w-6/12 m:mr-6">
            <copy-section
              :space-name="spaceName"
              :space-b2b="spaceB2b"
              :users-email="usersEmail"
              :is-user-logged-in="isUserLoggedIn"
              :did-user-just-login-or-signup="didUserJustLoginOrSignup"
            />

            <join-button :login-path="loginPath" :signup-path="signupPath" />

            <p v-if="!isUserLoggedIn" class="mt-4 mb-0 text-center m:text-left">
              {{ $t("alreadyHaveAnAccount") }}
              <a
                :href="loginPath"
                class="js-open-login-popup"
                :data-login-path="loginPath"
                :data-signup-path="signupPath"
              >
                {{ $t("login") }}
              </a>
            </p>
          </div>
          <space-image class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-8 l:pt-0 l:pl-20" />
        </div>
      </div>
    </tilted-background>
  </section>
</template>

<script>
import JoinButton from "./join-button"
import CopySection from "@/pages/spaces/join-page/components/copy-section"
import SpaceImage from "@/pages/spaces/join-page/components/space-image"
import TiltedBackground from "@/component-library/tilted-background"
import { mapGetters } from "vuex"
import { getSearchParam, getCurrentPageUrl, go } from "@/utils/location"

export default {
  name: "HeroSection",
  components: {
    SpaceImage,
    JoinButton,
    TiltedBackground,
    CopySection
  },
  props: {
    spaceName: {
      type: String,
      required: true
    },
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    },
    spaceB2b: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "usersEmail"]),
    didUserJustLoginOrSignup() {
      return getSearchParam("fromLoginSignup") === "true"
    }
  },
  methods: {
    goToNameInputPage() {
      go(`${getCurrentPageUrl()}/accept`)
    }
  },
  i18n: {
    messages: {
      en: {
        alreadyHaveAnAccount: "Already have an account?",
        login: "Log in"
      },
      de: {
        alreadyHaveAnAccount: "Du hast schon einen Account?",
        login: "Anmelden"
      }
    }
  }
}
</script>
